import { GYPSUM } from 'HubStyleTokens/colors';
import FileAttachment from '../FileAttachment';
import FileAttachmentWithProgress from '../FileAttachmentWithProgress';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
const FileDraftsListItem = ({
  file,
  progress,
  fileReference
}) => {
  if (fileReference) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        background: GYPSUM
      },
      children: /*#__PURE__*/_jsx(FileAttachment, {
        fileReference: fileReference
      })
    });
  }
  return /*#__PURE__*/_jsx(FileAttachmentWithProgress, {
    fileName: file.name,
    progress: progress
  });
};
const FileDraftsList = ({
  fileDraftsMap
}) => {
  return /*#__PURE__*/_jsx(UIList, {
    children: Array.from(fileDraftsMap.entries()).map(([file, {
      progress,
      fileReference
    }]) => {
      return /*#__PURE__*/_jsx(FileDraftsListItem, {
        file: file,
        progress: progress,
        fileReference: fileReference
      }, file.name);
    })
  });
};
export default FileDraftsList;